module.exports = __webpack_public_path__ + "static/huya-c26bba975166a3b4a722411848332855.png";